import { useConvertCurrency } from '@utils/currencyConverter';
import React from 'react';

import { COUNTRIES } from '../../constants/locations';
import { useCountryCode } from '../../hooks/useCountryCode';
import { useTaxPricing } from '../../hooks/useTaxPricing';
import { CountryCode } from '../../types/Locations';
import { formatPrice } from '../../utils/prices';

interface Props {
  className?: string;
  price: number;
  skipTaxCalculation?: boolean;
  countryCode?: CountryCode;
  skipConvertCurrency?: boolean;
  prefix?: string;
  inMinorUnit?: boolean;
}

export const ProductPrice = ({
  className,
  countryCode,
  inMinorUnit = false,
  prefix,
  price,
  skipConvertCurrency,
  skipTaxCalculation,
}: Props) => {
  const [userPreferencesCountryCode] = useCountryCode();
  const { calculateTaxPricing } = useTaxPricing({
    countryCode: countryCode || userPreferencesCountryCode,
  });
  const { currency, minorUnit, roundingFn } =
    COUNTRIES[countryCode || userPreferencesCountryCode];
  const { convert } = useConvertCurrency();

  const priceMinor = inMinorUnit ? price / minorUnit : price;

  const priceInSelectedCurrency = !skipConvertCurrency
    ? convert(priceMinor, currency)
    : priceMinor;

  const priceRounded = roundingFn
    ? roundingFn(priceInSelectedCurrency)
    : Math.round(priceInSelectedCurrency);

  const priceWithTaxes = !skipTaxCalculation
    ? calculateTaxPricing(priceRounded)
    : priceRounded;

  const pricing = formatPrice(priceWithTaxes, currency);

  return (
    <span className={className}>
      {prefix ? `${prefix} ${pricing}` : pricing}
    </span>
  );
};
